import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { FaCheck, FaCircle, FaLanguage, FaMailBulk, FaWhatsapp } from 'react-icons/fa';
import { PRIVACY_POLITICS_URL, SITE_KEY } from '../../store/constans';
import { createLeadThunk, initialStateLead } from '../../store/slices/pages/leads.slice';
import { useDispatch, useSelector } from 'react-redux';
import { countries } from "../../resources/optionsList";
import ReCAPTCHA from "react-google-recaptcha";
import bg from '../../assets/pruebas/IMG_3483.jpg';
import ely from '../../assets/pruebas/Sandra_Sales_Galapagos_Cruises.jpg';
import pauly from '../../assets/pruebas/Paulina_Sales_Galapagos_Cruises.jpg';
import { Toast } from '../../resources/utils';

const ContactUs = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const leadState = useSelector(state => state.leads);
    const recaptchaRef = useRef(null);

    const onSubmit = useCallback(async (data) => {

        const token = await recaptchaRef.current.executeAsync('lead_submit'); // Acción


        const dataWithCaptcha = {
            ...data,
            captchaToken: token,
            action: 'lead_submit',
        };

        dispatch(createLeadThunk(dataWithCaptcha));
    }, [dispatch]);

    useEffect(() => {
        if (leadState.message === "resource created successfully" || leadState.message === "Validation error") {
            const timer = setTimeout(() => {
                dispatch(initialStateLead());
                reset();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [leadState.message, dispatch, reset]);

    useEffect(() => {
        if (leadState.error) {
            Toast.fire({
                icon: 'error',
                title: leadState.error,
            });
        }
    }, [leadState.error]);

    return (
        <div name='contactUs' className='relative w-full flex flex-col md:p-8 h-full'>
            <img
                loading='lazy'
                src={bg}
                alt="Contact background"
                className="absolute top-0 left-0 w-full h-full object-cover"
            />
            <div className='relative md:p-2 text-white bg-gradient-to-r from-[#051937]/60 via-[#004d7a]/60 to-[#008793]/60 rounded-md md:shadow-lg md:shadow-black grid grid-cols-1 md:grid-cols-2'>
                <div className='flex flex-col justify-center items-center p-2 text-white border-b-2 md:border-b-0 md:border-r-2 text-[13px]'>
                    <div className='flex flex-col justify-center items-center p-5'>
                        <h2 className='text-[20px] font-semibold text-shadow-lg'>We’re here to help you plan your unique Galapagos cruise experience!</h2>
                        <p className='text-justify pt-3'>
                            At Rolf Wittmer & TipTopTravel, we specialize in crafting tailored First-Class cruise experiences in the Galapagos Islands. Our team of experts is ready to answer any questions you may have and assist you in organizing your perfect adventure.
                        </p>
                    </div>
                    <div className='flex flex-col gap-3 justify-center my-2'>
                        <p className='text-[15px] font-semibold'>Contact us today and start your journey to the Galapagos!</p>
                        <div className='flex gap-5 items-center pl-5 md:pl-0'>
                            <div className='bg-white shadow-sm shadow-white w-24 h-24 rounded-full p-[2px]'>
                                <img
                                    className='rounded-full object-cover w-full h-full'
                                    loading='lazy'
                                    src={pauly}
                                    alt="paulina-constante-galapagos-sales-executive"
                                />
                            </div>
                            <div className='text-start justify-start items-start'>
                                <div>
                                    <p className='text-[18px] font-semibold mb-[-6px]'>Paulina Constante</p>
                                    <p>Sales Executive</p>
                                </div>
                                <a
                                    className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'
                                    href='mailto:apaulina@tiptoptravel.ec'
                                    aria-label="Send email to Paulina Constante"
                                    target='_blank'
                                >
                                    <FaMailBulk /> apaulina@tiptoptravel.ec
                                </a>
                                <a
                                    className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'
                                    href='https://wa.link/m8bs3q'
                                    aria-label="Contact Paulina on WhatsApp"
                                    target='_blank'
                                >
                                    <FaWhatsapp /> +593 984891466
                                </a>
                                <p className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'>
                                    <FaLanguage /> German, English, Spanish
                                </p>
                            </div>
                        </div>
                        <div className='flex gap-5 items-center pl-5 md:pl-0'>
                            <div className='bg-white shadow-sm shadow-white w-24 h-24 rounded-full p-[2px]'>
                                <img
                                    className='rounded-full object-cover w-full h-full'
                                    loading='lazy'
                                    src={ely}
                                    alt="sandra-revelo-galapagos-sales-executive
"
                                />
                            </div>
                            <div className='text-start'>
                                <div>
                                    <p className='text-[18px] font-semibold mb-[-6px]'>Sandra Revelo</p>
                                    <p>Sales Executive</p>
                                </div>
                                <a
                                    className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'
                                    href='mailto:sandra@tiptoptravel.ec'
                                    aria-label="Send email to Sandra Rhor"
                                    target='_blank'
                                >
                                    <FaMailBulk /> sandra@tiptoptravel.ec

                                </a>
                                <a
                                    className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'
                                    href='https://wa.link/u7kidg'
                                    aria-label="Contact Eliana on WhatsApp"
                                    target='_blank'
                                >
                                    <FaWhatsapp /> +593 987987497
                                </a>
                                <p className='link link-hover flex items-center gap-3 py-2 px-4 rounded-md text-[15px]'>
                                    <FaLanguage /> English, Spanish
                                </p>
                            </div>
                        </div>
                        <div className='text-start flex flex-col gap-3 p-3'>
                            <p className='text-[15px] font-semibold'>Why Choose Us?</p>
                            <ul className='text-start pl-10 decoration-slice'>
                                <li className='flex items-center gap-2'>
                                    <FaCircle size={10} />
                                    Over 42 years of experience in the industry.
                                </li>
                                <li className='flex items-center gap-2'>
                                    <FaCircle size={10} />
                                    First-Class cruises with personalized service.
                                </li>
                                <li className='flex items-center gap-2'>
                                    <FaCircle size={10} />
                                    Exclusive itineraries in the Galapagos Islands.
                                </li>
                                <li className='flex items-center gap-2'>
                                    <FaCircle size={10} />
                                    A team of experts passionate about nature and conservation.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div name='contactForm'>
                    <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col justify-center m-3 md:m-8 text-start p-2 md:gap-2'>
                        <div className="space-y-4">
                            {/* First Name */}
                            <div>
                                <label htmlFor="firstName" className="block text-sm font-semibold">First Name</label>
                                <input
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("firstName", { required: "First Name is required" })}
                                    aria-describedby="firstNameError"
                                />
                                {errors.firstName && (
                                    <span id="firstNameError" className="text-red-500 text-xs font-semibold">
                                        {errors.firstName.message}
                                    </span>
                                )}
                            </div>

                            {/* Last Name */}
                            <div>
                                <label htmlFor="lastName" className="block text-sm font-semibold">Last Name</label>
                                <input
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("lastName", { required: "Last Name is required" })}
                                    aria-describedby="lastNameError"
                                />
                                {errors.lastName && (
                                    <span id="lastNameError" className="text-red-500 text-xs font-semibold">
                                        {errors.lastName.message}
                                    </span>
                                )}
                            </div>

                            {/* E-mail */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-semibold">E-mail</label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("email", { required: "E-mail is required" })}
                                    aria-describedby="emailError"
                                />
                                {errors.email && (
                                    <span id="emailError" className="text-red-500 text-xs font-semibold">
                                        {errors.email.message}
                                    </span>
                                )}
                            </div>

                            {/* Country */}
                            <div>
                                <label htmlFor="country" className="block text-sm font-semibold">Country</label>
                                <select
                                    id="country"
                                    name="country"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("country", { required: "Country is required" })}
                                    aria-describedby="countryError"
                                >
                                    <option value="">Select a Country</option>
                                    {countries.map((country) => (
                                        <option key={country.name} value={country.label}>
                                            {country.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.country && (<span id="countryError" className="text-red-500 text-xs font-semibold">{errors.country.message}
                                </span>
                                )}
                            </div>

                            {/* Phone */}
                            <div>
                                <label htmlFor="phone" className="block text-sm font-semibold">Phone Number</label>
                                <input
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("phone", { required: "Phone Number is required" })}
                                    aria-describedby="phoneError"
                                />
                                {errors.phone && (
                                    <span id="phoneError" className="text-red-500 text-xs font-semibold">
                                        {errors.phone.message}
                                    </span>
                                )}
                            </div>

                            {/* Message */}
                            <div>
                                <label htmlFor="message" className="block text-sm font-semibold">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    className="w-full p-2 text-gray-700 text-[16px] bg-white/70 rounded-md border-b-2 focus:outline-none"
                                    {...register("message", { required: "Message is required" })}
                                    aria-describedby="messageError"
                                />
                                {errors.message && (
                                    <span id="messageError" className="text-red-500 text-xs font-semibold">
                                        {errors.message.message}
                                    </span>
                                )}
                            </div>

                            <ReCAPTCHA
                                sitekey={SITE_KEY}
                                size="invisible"
                                ref={recaptchaRef}
                            />

                            {/* Privacy Policy */}
                            <div className="flex items-center gap-2">
                                <input
                                    id="readPolitics"
                                    name="readPolitics"
                                    type="checkbox"
                                    className="cursor-pointer"
                                    {...register("readPolitics", { required: "You must accept our privacy policies" })}
                                    aria-describedby="privacyPolicyError"
                                />
                                <label htmlFor="readPolitics" className="text-sm">
                                    I accept the{" "}
                                    <a href={PRIVACY_POLITICS_URL} target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:text-orange-800">
                                        privacy policy
                                    </a>
                                </label>
                                {errors.readPolitics && (
                                    <span id="privacyPolicyError" className="text-red-500 text-xs font-semibold">
                                        {errors.readPolitics.message}
                                    </span>
                                )}
                            </div>

                            {/* Subscription */}
                            <div className="flex items-center gap-2">
                                <input
                                    id="isSuscriptor"
                                    name="isSuscriptor"
                                    type="checkbox"
                                    className="cursor-pointer"
                                    {...register("isSuscriptor")}
                                />
                                <label htmlFor="isSuscriptor" className="text-sm">Subscribe to our news</label>
                            </div>
                            {
                                leadState.message === "Validation error" ?
                                    <div className='bg-green-500/50 p-3 px-8 flex gap-3 items-center rounded-md'>
                                        <h2>You are already part of our community, an advisor will contact you immediately</h2>
                                    </div>
                                    :
                                    leadState.message === "resource created successfully" ?
                                        <div className='bg-green-500/50 p-3 px-8 flex gap-3 items-center rounded-md'>
                                            <h2>Form send successfully</h2>
                                            <FaCheck />
                                        </div>
                                        :
                                        <div className='w-full flex justify-center mt-5'>
                                            {leadState.fetching ?
                                                <div className='flex flex-col items-center justify-center'>
                                                    <span className="loading loading-ring loading-lg"></span>
                                                    <h2>Sending</h2>
                                                </div>
                                                :
                                                <button
                                                    className='text-[15px] md:text-[15px] uppercase border px-8 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500 duration-75 hover:border-white'>
                                                    Submit
                                                </button>
                                            }
                                        </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
